import { Router } from '@angular/router';
import { htmlUrls } from '@shared/utils/router-paths';
import { SharedModule } from '@shared/module/shared.module';
import { LocalRepository } from '@shared/helper/local-repository';
import { FollowsModel } from '@shared/model/followModels/follow-model';
import { BaseComponent } from '@shared/components/base/base.component';
import { FollowStateEnum } from '@shared/model/enum/follow-state-enum';
import { FollowBtnComponent } from '../follow-btn/follow-btn.component';
import { FollowItemService } from '@shared/service/follow-item.service';
import { HeaderConfigModel } from '../header/header.component';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LikeAggrigatorModel } from '@shared/model/Activity_Aggtigator/like-aggrigator-model';
import { FollowUserDataPipe, IFollowStateData } from '../follow-btn/pipe/follow-user-data.pipe';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, OnInit, inject } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { LikeAggrigatorService } from '@shared/service/http_services/Activity_Aggrigator/likeAggrigator.service';
import { EImageType } from '@shared/pipes/image.pipe';
import { CommentsAggrigatorService } from '@shared/service/http_services/commentsAggrigator.service';
import { UserTypeEnum } from '@shared/model/enum/user-type-enum';
import { AuthContainerDialogComponent } from '@app/auth/auth-container-dialog/auth-container-dialog.component';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@Component({
  selector: 'app-activity-liked-users',
  templateUrl: './activity-liked-users.component.html',
  styleUrls: ['./activity-liked-users.component.scss'],
  imports: [
    SharedModule,
    FollowBtnComponent,
    FollowUserDataPipe,
    InfiniteScrollModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityLikedUsersComponent extends BaseComponent implements OnInit {
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private cdr = inject(ChangeDetectorRef);
  private bottomSheet = inject(MatBottomSheet);
  private _localRepository = inject(LocalRepository);
  private followItemService = inject(FollowItemService);
  private likeAggrigatorService = inject(LikeAggrigatorService);
  private _commentsAggrigatorService = inject(CommentsAggrigatorService);


  private dialogData;
  private dialogRef: any = null;
  private bottomSheetData;
  private bottomSheetRef: any = null;

  followModel: FollowsModel = new FollowsModel();
  routes = htmlUrls;
  dataUser: LikeAggrigatorModel[] = [];
  loadingMore = false;
  data: any;
  loading = true;
  hasMoreActivity!: boolean;
  profileOwner = false;
  followeState = FollowStateEnum;
  loadingFollow = false;
  loadingUnFollow = false;
  loadingIndex!: number;
  usersTermFilter: TermFilterModel = new TermFilterModel();
  imageType = EImageType;
  userTypeEnum = UserTypeEnum

  headerConfig: HeaderConfigModel = {
    title: 'افرادی که پسندیدند',
    dialogHeader: true
  }

  constructor() {
    const injector = inject(Injector);

    super();
    this.dialogRef = injector.get(MatDialogRef, null);
    this.dialogData = injector.get(MAT_DIALOG_DATA, null);
    this.bottomSheetRef = injector.get(MatBottomSheetRef, null);
    this.bottomSheetData = injector.get(MAT_BOTTOM_SHEET_DATA, null);
  }

  ngOnInit(): void {

    if (this._localRepository.IsInMobile) {
      this.data = this.bottomSheetData;
    }
    else {
      this.data = this.dialogData;
    }

    this.usersTermFilter.pgNumber = 0;
    this.usersTermFilter.pgSize = 10;

    if (this.data.isReacted) {
      this._commentsAggrigatorService.getReactionsByItem(this.data.objectId, this.usersTermFilter)
        .subscribe(users => {
          if (!users.hasError) {
            this.dataUser = users.result?.items;
            this.hasMoreActivity = users.result?.hasNextPage;
          }
          this.loading = false;
          this.cdr.detectChanges();
        });
    }
    else {
      this.likeAggrigatorService.getLikeByItem(this.data.objectId, this.usersTermFilter)
        .subscribe(users => {
          if (!users.hasError) {
            this.dataUser = users.result?.items;
            this.hasMoreActivity = users.result?.hasNextPage;
            this.loading = false;
          }
          this.cdr.detectChanges();
        });
    }

  }

  openSigninDialog() {
    const curl = this.router.url;
    if (this._localRepository.IsInMobile) {
      this.utilFunctions.opensigninAlertBottomSheet(this.dialog, curl, this._localRepository);
    }
    else {
      this.utilFunctions.opensigninDialog(this.dialog, curl, this._localRepository);
    }
  }

  loadMore() {
    if (this.hasMoreActivity) {
      this.usersTermFilter = { ...this.usersTermFilter, pgNumber: this.usersTermFilter.pgNumber + 1 };
      this.loadingMore = true;
      this.likeAggrigatorService.getLikeByItem(this.data.objectId, this.usersTermFilter)
        .subscribe(users => {
          this.loadingMore = users.result.hasNextPage;
          if (!users.hasError) {
            users.result?.items.forEach(user => {
              this.dataUser.push(user);
            });
            this.hasMoreActivity = users.result?.hasNextPage;
          }
          this.loadingMore = false;
          this.cdr.detectChanges();
        })
    }
  }


  FollowClicked(item: IFollowStateData) {
    if (this.currentUser) {
      this.followItemService.Follow(item);
    } else {
      this.openAuthDialog();
      this.close();
    }
  }

  openAuthDialog() {
    this.dialog.open(AuthContainerDialogComponent, {
      panelClass: 'auth-dialog',
      disableClose: true
    });
  }

  close() {
    if (this._localRepository.IsInMobile) {
      this.bottomSheetRef.dismiss();
    }
    else {
      this.dialogRef.close();
    }
  }
}
